import { PieChart } from "lucide-react";
import type { FengniaoDashboard } from "../hooks/useFengniaoDashboard";
import { formatBps } from "../lib/format";
import { SplitBar } from "./SplitBar";

interface SplitPanelProps {
  dashboard: FengniaoDashboard;
}

interface LegendRow {
  color: string;
  label: string;
  bps: number;
}

export function SplitPanel({ dashboard }: SplitPanelProps) {
  const { split } = dashboard;

  const rows: LegendRow[] = [
    { color: "bg-wing", label: "持币分 LP", bps: split.holderBps },
    { color: "bg-bnb", label: "LP 时间分 BNB", bps: split.lpTimeBps },
    { color: "bg-ember", label: "回购销毁", bps: split.burnBps },
  ];

  return (
    <section className="glass p-5 lg:p-6">
      <header className="flex items-center gap-2.5 mb-2">
        <PieChart className="w-5 h-5 text-wing" strokeWidth={1.75} aria-hidden />
        <h3 className="text-sm font-mono uppercase tracking-wider text-ink">税收分流</h3>
      </header>
      <p className="text-xs text-ink-dim leading-relaxed mb-5">
        每笔买卖税自动分流到三个 vault，比例由 owner 配置。
      </p>

      <SplitBar
        holderBps={split.holderBps}
        lpTimeBps={split.lpTimeBps}
        burnBps={split.burnBps}
      />

      <ul className="mt-5 space-y-2.5">
        {rows.map((row) => (
          <li key={row.label} className="flex items-center justify-between gap-3">
            <span className="flex items-center gap-2.5">
              <span className={`w-3 h-3 rounded-sm ${row.color}`} aria-hidden />
              <span className="text-sm text-ink">{row.label}</span>
            </span>
            <span className="text-sm font-mono tabular-nums text-ink-dim">
              {formatBps(BigInt(row.bps))}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
